// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalCorporateSession {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  margin-left: 0px;
  z-index: 999;
}

.widthCustom .modal {
  width: 620px;
  max-width: 620px;
}

.widthCustom .modal img {
  display: none;
}

.widthCustom .buttonsEdit {
  justify-content: space-between;
}

.widthCustom .titleDescription {
  font-size: 23px;
}

.widthCustom .buttonsEdit button:nth-last-child(2) {
  position: relative;
  left: 60px;
}

.widthCustom .lastButton {
  width: 180px;
}

.modalDowload {
  margin-left: -65px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  max-width: 540px;
  min-width: 270px;
  min-height: 150px;
  background-color: white;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 999;
  text-align: start;
  border-top: 6px solid #007bc0;
}

.titleModal {
  font-size: 16px;
  font-weight: 600;
}

.titleDescription {
  font-size: 18px;
  font-weight: 700;
}

.buttonsEdit {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 15px;
  margin-bottom: 15px;
  gap: 25px;
}

.containerTitleModal {
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.containerDescription {
  padding: 5px 20px;
  display: flex;
  flex-direction: column;
}

.line {
  background-color: #c1c7cc;
  width: 100%;
  height: 1px;
}

.bodyModal {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  font-size: 15px;
}

.bodyModal div strong {
  margin-top: 10px;
  display: block;
  margin-bottom: -10px;
}

.bodyModal div strong.sessao {
  margin-top: 10px;
  display: inline;
  margin-bottom: -10px;
}

.bodyModal .paragraph {
  margin-bottom: 20px;
  margin-top: -25px;
  font-size: 18px;
}

.bodyModal .paragraph_custom {
  margin-bottom: 20px;
  margin-top: -25px;
  font-size: 18px;
  text-align: left;
}

button .buttonGeneric .buttonHover:hover {
  background-color: #00629a;
  color: #fff;
}

button.buttonGeneric.buttonHover {
  background-color: #007bc0;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/modalSession/modalSession.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":[".modalCorporateSession {\n  display: flex;\n  position: fixed;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-left: 0px;\n  z-index: 999;\n}\n\n.widthCustom .modal {\n  width: 620px;\n  max-width: 620px;\n}\n\n.widthCustom .modal img {\n  display: none;\n}\n\n.widthCustom .buttonsEdit {\n  justify-content: space-between;\n}\n\n.widthCustom .titleDescription {\n  font-size: 23px;\n}\n\n.widthCustom .buttonsEdit button:nth-last-child(2) {\n  position: relative;\n  left: 60px;\n}\n\n.widthCustom .lastButton {\n  width: 180px;\n}\n\n.modalDowload {\n  margin-left: -65px;\n}\n\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  flex-direction: column;\n  max-width: 540px;\n  min-width: 270px;\n  min-height: 150px;\n  background-color: white;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);\n  z-index: 999;\n  text-align: start;\n  border-top: 6px solid #007bc0;\n}\n\n.titleModal {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.titleDescription {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.buttonsEdit {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-top: 15px;\n  margin-bottom: 15px;\n  gap: 25px;\n}\n\n.containerTitleModal {\n  padding: 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.containerDescription {\n  padding: 5px 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.line {\n  background-color: #c1c7cc;\n  width: 100%;\n  height: 1px;\n}\n\n.bodyModal {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  font-size: 15px;\n}\n\n.bodyModal div strong {\n  margin-top: 10px;\n  display: block;\n  margin-bottom: -10px;\n}\n\n.bodyModal div strong.sessao {\n  margin-top: 10px;\n  display: inline;\n  margin-bottom: -10px;\n}\n\n.bodyModal .paragraph {\n  margin-bottom: 20px;\n  margin-top: -25px;\n  font-size: 18px;\n}\n\n.bodyModal .paragraph_custom {\n  margin-bottom: 20px;\n  margin-top: -25px;\n  font-size: 18px;\n  text-align: left;\n}\n\nbutton .buttonGeneric .buttonHover:hover {\n  background-color: #00629a;\n  color: #fff;\n}\n\nbutton.buttonGeneric.buttonHover {\n  background-color: #007bc0;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
